var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { createPortal } from "react-dom";
import { useFloating, autoUpdate, offset, flip, hide } from "@floating-ui/react";
import { arrow } from "@floating-ui/core";
var FloatingUI = React.forwardRef(function (_a, ref) {
    var _b, _c, _d;
    var open = _a.isOpen, placement = _a.placement, anchorEl = _a.anchorEl, offsetProp = _a.offset, arrowEl = _a.arrowEl, portal = _a.portal, children = _a.children, allowFlip = _a.allowFlip, divElementProps = __rest(_a, ["isOpen", "placement", "anchorEl", "offset", "arrowEl", "portal", "children", "allowFlip"]);
    var _e = useFloating({
        open: open,
        placement: placement,
        elements: {
            reference: anchorEl
        },
        middleware: [
            offsetProp
                ? offset({
                    mainAxis: offsetProp
                })
                : null,
            hide({
                boundary: "clippingAncestors",
                rootBoundary: "viewport"
            }),
            allowFlip
                ? flip({
                    boundary: "clippingAncestors",
                    rootBoundary: "viewport"
                })
                : null,
            arrowEl
                ? arrow({
                    element: arrowEl
                })
                : null
        ].filter(function (x) { return x != null; }),
        whileElementsMounted: autoUpdate
    }), setFloating = _e.refs.setFloating, floatingStyles = _e.floatingStyles, context = _e.context;
    var floatingRefReceiver = React.useCallback(function (receivedRef) {
        if (ref) {
            if (typeof ref === "function") {
                ref(receivedRef);
            }
            else {
                ref.current = receivedRef;
            }
        }
        setFloating(receivedRef);
    }, [ref, setFloating]);
    if (!open) {
        return null;
    }
    var display = (_c = (_b = divElementProps.style) === null || _b === void 0 ? void 0 : _b.display) !== null && _c !== void 0 ? _c : floatingStyles.display;
    if ((_d = context.middlewareData.hide) === null || _d === void 0 ? void 0 : _d.referenceHidden) {
        display = "none";
    }
    var contentNode = (React.createElement("div", __assign({ ref: floatingRefReceiver }, divElementProps, { style: __assign(__assign(__assign({}, floatingStyles), divElementProps.style), { display: display }) }), typeof children === "function" ? children(context) : children));
    if (portal) {
        return createPortal(contentNode, document.body);
    }
    else {
        return contentNode;
    }
});
FloatingUI.defaultProps = {
    portal: true
};
export default FloatingUI;
//# sourceMappingURL=FloatingUI.js.map